module.exports = __webpack_public_path__ + "static/media/V3.1ad2c1e6.pdf";